"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.riskIdColorPicker = exports.riskThreshold = exports.isRiskIdValid = exports.FIRE_BLIGHT_DEFAULT = exports.FIRE_BLIGHT_HISTORICAL_RISK_CONFIGURATION = exports.FIRE_BLIGHT_HISTORICAL_RISK_CONFIGURATION_BY_ID = void 0;
const yellow = 'rgba(255, 238, 79, 1)';
const orange = 'rgba(254, 148, 2, 1)';
const red = 'rgba(229, 53, 0, 1)';
const colors = {
    fireBlightMarginalRisk: yellow,
    fireBlightHighRisk: orange,
    fireBlightExtremeRisk: red,
};
const FIRE_BLIGHT_NONE = 'FIRE_BLIGHT_NONE';
const FIRE_BLIGHT_LAST_YEAR = 'FIRE_BLIGHT_LAST_YEAR';
const FIRE_BLIGHT_ACTIVE = 'FIRE_BLIGHT_ACTIVE';
exports.FIRE_BLIGHT_HISTORICAL_RISK_CONFIGURATION_BY_ID = {
    FIRE_BLIGHT_NONE: {
        id: FIRE_BLIGHT_NONE,
        translatableDescription: 'No fire blight in area for at least 1 year',
        threshold: {
            marginal: {
                low: 0,
                high: 400,
            },
            high: {
                low: 400,
                high: 800,
            },
            extreme: {
                low: 800,
                high: 99999999,
            },
        },
    },
    FIRE_BLIGHT_LAST_YEAR: {
        id: FIRE_BLIGHT_LAST_YEAR,
        translatableDescription: 'Fire blight in area last year',
        threshold: {
            marginal: {
                low: 0,
                high: 150,
            },
            high: {
                low: 150,
                high: 350,
            },
            extreme: {
                low: 350,
                high: 99999999,
            },
        },
    },
    FIRE_BLIGHT_ACTIVE: {
        id: FIRE_BLIGHT_ACTIVE,
        translatableDescription: 'Fire blight is currently active in area',
        threshold: {
            marginal: {
                low: 0,
                high: 80,
            },
            high: {
                low: 80,
                high: 200,
            },
            extreme: {
                low: 200,
                high: 99999999,
            },
        },
    },
};
exports.FIRE_BLIGHT_HISTORICAL_RISK_CONFIGURATION = [
    exports.FIRE_BLIGHT_HISTORICAL_RISK_CONFIGURATION_BY_ID[FIRE_BLIGHT_NONE],
    exports.FIRE_BLIGHT_HISTORICAL_RISK_CONFIGURATION_BY_ID[FIRE_BLIGHT_LAST_YEAR],
    exports.FIRE_BLIGHT_HISTORICAL_RISK_CONFIGURATION_BY_ID[FIRE_BLIGHT_ACTIVE],
];
exports.FIRE_BLIGHT_DEFAULT = FIRE_BLIGHT_ACTIVE;
const isRiskIdValid = (riskId) => {
    return exports.FIRE_BLIGHT_HISTORICAL_RISK_CONFIGURATION.some((risk) => risk.id === riskId);
};
exports.isRiskIdValid = isRiskIdValid;
const riskThreshold = (riskId) => {
    const risk = exports.FIRE_BLIGHT_HISTORICAL_RISK_CONFIGURATION_BY_ID[riskId];
    return risk.threshold;
};
exports.riskThreshold = riskThreshold;
const isMarginalRisk = (value, threshold) => threshold.marginal.low <= value && value < threshold.marginal.high;
const isHighRisk = (value, threshold) => threshold.high.low <= value && value < threshold.high.high;
const isExtremeRisk = (value, threshold) => threshold.extreme.low <= value && value < threshold.extreme.high;
const makeRiskColorPicker = (riskId) => {
    const threshold = (0, exports.riskThreshold)(riskId);
    return (value) => {
        if (isMarginalRisk(value, threshold))
            return colors.fireBlightMarginalRisk;
        if (isHighRisk(value, threshold))
            return colors.fireBlightHighRisk;
        if (isExtremeRisk(value, threshold))
            return colors.fireBlightExtremeRisk;
    };
};
exports.riskIdColorPicker = {
    [FIRE_BLIGHT_NONE]: makeRiskColorPicker(FIRE_BLIGHT_NONE),
    [FIRE_BLIGHT_LAST_YEAR]: makeRiskColorPicker(FIRE_BLIGHT_LAST_YEAR),
    [FIRE_BLIGHT_ACTIVE]: makeRiskColorPicker(FIRE_BLIGHT_ACTIVE),
};
//# sourceMappingURL=fireBlight.js.map